import { NgModule } from '@angular/core';
import { LogoHeaderComponent } from './logo-header/logo-header';
import { BannerComponent } from './banner/banner';
import {IonicModule} from "ionic-angular";
import {RoundToNearestHalfPipe} from "../services/round-to-nearest-half.pipe";
import {RoundFivesPipe} from "../services/round-fives.pipe";
import {RoundTensPipe} from "../services/round-tens.pipe";
@NgModule({
	declarations:[
	  LogoHeaderComponent,
    BannerComponent,
    RoundToNearestHalfPipe,
    RoundFivesPipe,
    RoundTensPipe,
  ],
	imports: [IonicModule],
	exports: [
	  LogoHeaderComponent,
    BannerComponent,
    RoundToNearestHalfPipe,
    RoundFivesPipe,
    RoundTensPipe,
  ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts